import "../scss/index.scss";

// npmから直でinstallできないのでやり方が特殊になっている
import cheet from "./lib/namuol-cheet.js/cheet.js"; 
import baron from "baron";
import MicroModal from "micromodal";
import Splide from "@splidejs/splide";
import validator from 'validator';
import {loadStripe} from '@stripe/stripe-js';


/*
[\[JavaScript\]\[Node\.js\] requireされた側でrequireした側の変数を参照する \#JavaScript \- Qiita](https://qiita.com/shinchit/items/b59f5e9f3b54217e133f)
*/

const { scrollout_init } = require('./lib/ushiya/scrollout_init/');

const { init_stripe,mount_stripe_card } = require('./sub/stripe.js');


const {page1_next} = require('./application_form/page1.js');
const {page2_prev,page2_next} = require('./application_form/page2.js');
const {page3_prev,page3_next} = require('./application_form/page3.js');
const {page4_prev,page4_next} = require('./application_form/page4.js');
const {page5_once,page5_prev,page5_next} = require('./application_form/page5.js');

const backend_fqdn= from_webpack.backend_fqdn;

const { 
    define_svg_element,
    emit_on_all_svg_loaded,
    //emit_on_all_svg_full_loaded,
    define_footer_element,
    define_splide_slide_element,
    emit_on_all_splide_slide_loaded
} = require('./lib/ushiya/custom_element');

/*
const fetch_option = {
    method: 'POST',
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    },
    mode: 'cors',
    credentials: 'include' // クッキーの送信
};
*/

define_svg_element();   
define_footer_element();
define_splide_slide_element();

let ticking = false;

window.splide_instance = null;
// 一時公開
window.backend_fqdn = backend_fqdn;


const scrollout_custom_handler = (e,so,hidden) =>{
    // e... ビューポートに出現した要素(DOMオブジェクト)
    // so... ScrollOutオブジェクトインスタンス
    // hidden... 要素がビューポート外に出た場合はtrue、それ以外はfalse


    if(hidden){
        /*
        if(e.matches('section.top-most-section')){
            let DOM_navigation_svg=document.querySelector('#navigation01');
        
            if(DOM_navigation_svg){

                DOM_navigation_svg.classList.add('away-from-top');
            }
        }
        if(e.matches('#section_archive_2022_chairperson_container #content-area')){
            let DOM_svg=e.closest('svg');
            DOM_svg.classList.remove('text_appear');
        }
        */

    } else {
        
        if(e.matches('section.top-most-section')){
            let DOM_navigation_svg=document.querySelector('#navigation01');
        
            if(DOM_navigation_svg){

                DOM_navigation_svg.classList.remove('away-from-top');
            }
        }
        /*
        if(e.matches('#fade_to_white')){

            if(DOM_main_scroll_area){
                let go_down = (DOM_main_scroll_area.dataset['scrollDirY'] == 1);
                let go_up = (DOM_main_scroll_area.dataset['scrollDirY'] == -1);
                if(go_up) {
                    DOM_main_scroll_area.classList.remove('whiteen');
                }
                if(go_down) {
                }

            }
                    
        }

        if(e.matches('#section_overview')){

            if(DOM_main_scroll_area){
                let go_down = (DOM_main_scroll_area.dataset['scrollDirY'] == 1);
                let go_up = (DOM_main_scroll_area.dataset['scrollDirY'] == -1);
                if(go_down) {
                    DOM_main_scroll_area.classList.add('whiteen');
                }
            }
        }
        */
    }
}


const init_scrollbar = () => {
    baron({
        root: '.baron',
        scroller: '.baron__scroller',
        bar: '.baron__bar'
    });
}

const enable_debug_command = () => {

    cheet('2 3 6 p', 
        {
            done:function () {
                debugger;
                if(window.splide_instance){
                    window.splide_instance.go("6");
                }                
            }
        }
    );

    cheet('2 1 4 k', 
        {
            done:function () {
                let DOM_check_accept_term = document.querySelector(`[data-page="1"] [name="accept_term"]`);

                let DOM_select_category = document.querySelector(`[data-page="2"] [name="category"]`);
                let DOM_select_voice_type = document.querySelector(`[data-page="2"] [name="voice_type"]`);
                let DOM_textarea_career = document.querySelector(`[data-page="2"] [name="career"]`);

                let DOM_input_name  = document.querySelector(`[data-page="3"] [name="name"]`);
                let DOM_input_email = document.querySelector(`[data-page="3"] [name="email"]`);
                let DOM_input_birthdate   = document.querySelector(`[data-page="3"] [name="birthdate"]`);
                let DOM_input_tel   = document.querySelector(`[data-page="3"] [name="tel"]`);
                
                
                let DOM_input_watch_url               = document.querySelector(`[data-page="4"] [name="watch_url"]`);
                let DOM_input_composer                = document.querySelector(`[data-page="4"] [name="composer"]`);
                let DOM_input_workname                = document.querySelector(`[data-page="4"] [name="workname"]`);
                let DOM_input_title_original_language = document.querySelector(`[data-page="4"] [name="title_original_language"]`);
                let DOM_input_title_local_language    = document.querySelector(`[data-page="4"] [name="title_local_language"]`);
                
                DOM_check_accept_term.checked=true;
                DOM_select_category.selectedIndex=1;
                DOM_select_voice_type.selectedIndex=1;
                DOM_textarea_career.value="経歴ｘｘｘｘｘｘｘｘｘ";
                
                DOM_input_name.value="hoge";
                DOM_input_email.value="calloc@ae.auone-net.jp";
                DOM_input_birthdate.value="1980-05-01";
                DOM_input_tel.value="06-XXXX-XXXX";
                
                DOM_input_watch_url.value="https://www.youtube.com/xxxxxx";
                DOM_input_composer.value="aaaa";
                DOM_input_workname.value="bbbb";
                DOM_input_title_original_language.value="cccc";
                DOM_input_title_local_language.value="dddd";
            }
        }
    );
}

const main_scroll_area_jump_to = (selector) => {

	let DOM_main_scroll_area;

	DOM_main_scroll_area = document.getElementById(`main_scroll_area`);
	
	if(!DOM_main_scroll_area === null) {
		throw new Error('assertion fail: main scroll area not find');		
	}
	
	let DOM_jump_to;

	DOM_jump_to = document.querySelector(selector);
	
	if(DOM_jump_to === null) return;
	
	DOM_jump_to.scrollIntoView({ behavior: "smooth" });

}

const activate_section_apply = () => {
    let DOM_section_apply_externsvg;
    DOM_section_apply_externsvg = document.querySelector('extern-svg[data-mountpoint="section_apply"]');
    if(DOM_section_apply_externsvg === null) return;

    let DOM_svg=DOM_section_apply_externsvg;
    DOM_svg.addEventListener('jump_to_participation_fee',()=>{
        main_scroll_area_jump_to("#section_participation_fee");
    });
    DOM_svg.addEventListener('jump_to_requirement',()=>{
        main_scroll_area_jump_to("#section_requirement");
    });
    DOM_svg.addEventListener('jump_to_program',()=>{
        main_scroll_area_jump_to("#section_program");
    });

}

const activate_section_contact = () => {
    let DOM_section_contact_externsvg;
    DOM_section_contact_externsvg = document.querySelector('extern-svg[data-mountpoint="section_contact"]');
    if(DOM_section_contact_externsvg === null) return;

    DOM_section_contact_externsvg.addEventListener('svgready',
        (e)=>{
            let DOM_svg=e.target.querySelector(':scope svg');
            DOM_svg.addEventListener('contact_email_click',()=>{
                location.href = "mailto:nagoyaitalianoperacompetition@gmail.com";
            });

        }
    );
}


window.addEventListener('all_svg_ready',
    (e)=>{
        console.log("all_svg_ready");
        MicroModal.init();
        scrollout_init({
            special_scrollin:scrollout_custom_handler
        });
        activate_section_apply();
    }
);


var application_context={
    page:0,
    DOM:{
        button_go_next:null,
        button_go_prev:null,
        button_close:null
    },
    library:{
        validator:validator
    },
    ary_verify_error:[],
    ary_run_once:{},
    ary_page_transition:[
        {prev:null,next:page1_next}, //page1
        {prev:page2_prev,next:page2_next}, //page2
        {prev:page3_prev,next:page3_next}, //page3
        {prev:page4_prev,next:page4_next},  //page4
        {once:page5_once,prev:page5_prev,next:page5_next},  //page5
        {prev:null,next:null}  //page6
    ]
};



window.addEventListener('allsplideslideloaded',async (e)=>{

    application_context.DOM.button_go_next = document.querySelector('#modal-1 .go_next');
    application_context.DOM.button_go_prev = document.querySelector('#modal-1 .go_previous');
    application_context.DOM.button_close = document.querySelector('#modal-1 .cancel_apply');

    application_context.DOM.button_go_prev.classList.add("invisible");

    application_context.DOM.button_go_next.addEventListener('click',(e)=>{
        let page=application_context.page;
        let ary_page_transition = application_context.ary_page_transition;
        if(ary_page_transition[page] && ary_page_transition[page].next){
            ary_page_transition[page].next(application_context);
        }

    });
    application_context.DOM.button_go_prev.addEventListener('click',(e)=>{
        let page=application_context.page;
        let ary_page_transition = application_context.ary_page_transition;
        if(ary_page_transition[page] && ary_page_transition[page].prev){
            ary_page_transition[page].prev(application_context);
        }

        
    });

    // FIXME:
    // stripe関係の処理をうまく分離できなかったので
    // 初期化処理の呼び方が汚くなっている
    // 可能なら直す。
    await init_stripe(loadStripe);
    mount_stripe_card();

});




window.addEventListener('DOMContentLoaded',async (event)=>{
    
    // 後で画像参照も使うのであとで
    //emit_on_all_svg_full_loadedの呼び出しに変更する

    emit_on_all_svg_loaded(
        [
            "extern-svg[data-mountpoint='section_main_visual_sp']",
            "extern-svg[data-mountpoint='section_main_visual_pc']",
            "extern-svg[data-mountpoint='section_overview']",
            "extern-svg[data-mountpoint='section_schedule']",
            "extern-svg[data-mountpoint='section_category']",
            "extern-svg[data-mountpoint='section_participation_fee']",
            "extern-svg[data-mountpoint='section_prize']",
            "extern-svg[data-mountpoint='section_award']",
            "extern-svg[data-mountpoint='section_program']",
            "extern-svg[data-mountpoint='section_requirement']",
            "extern-svg[data-mountpoint='section_jury_header']",
            "extern-svg[data-mountpoint='section_jury_part1']",
            "extern-svg[data-mountpoint='section_jury_part2']",
            "extern-svg[data-mountpoint='section_jury_part3']",
            "extern-svg[data-mountpoint='section_jury_part4']",
            "extern-svg[data-mountpoint='section_jury_part5']",
            "extern-svg[data-mountpoint='section_contact']",
            "extern-svg[data-mountpoint='section_support_by_header']",
            "extern-svg[data-mountpoint='section_support_by_part1']",
            "extern-svg[data-mountpoint='section_support_by_part2']"
        ]

    );

    emit_on_all_splide_slide_loaded(
        ['./slide1.html','./slide2.html','./slide3.html']
    );

    activate_section_contact();
    //activate_section_apply_button();


    document.querySelector('extern-svg[data-mountpoint="navigation"]').addEventListener('svgready',
        (e)=>{

            let DOM_svg=e.target.querySelector(':scope svg');
            DOM_svg.addEventListener('toggle_slide_menu',()=>{
                document.body.classList.toggle("slide_menu_open");
            });

        }
    );

    init_scrollbar();
    
    //enable_debug_command();

});